import { SCROLL_SLIDER_WHEEL_LINE_HEIGHT } from './ScrollSlider.constants'

export function checkIsEndOfContainer(element) {
  return (
    element.scrollWidth <=
    Math.ceil(element.scrollLeft) +
      Math.ceil(element.getBoundingClientRect().width)
  )
}

export function checkIsStartOfContainer(element) {
  return element.scrollLeft === 0
}

// A vertical wheel scrolls the row sideways until its end, then the page scrolls on
export function getScrollSliderWheelOffset({ event, slider }) {
  const offset =
    event.deltaMode === WheelEvent.DOM_DELTA_LINE
      ? event.deltaY * SCROLL_SLIDER_WHEEL_LINE_HEIGHT
      : event.deltaY

  const canScroll =
    Math.abs(event.deltaY) > Math.abs(event.deltaX) &&
    (offset > 0
      ? !checkIsEndOfContainer(slider)
      : offset < 0 && !checkIsStartOfContainer(slider))

  return canScroll ? offset : 0
}
